import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';

import { environment } from '../../../../environments/environment';
import { TeilpaketKraft } from "./Model/TeilpaketKraft";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs/index";

@Injectable()
export class KraftpaketService extends RESTService<TeilpaketKraft>{

  constructor(
    public http:HttpInterceptorService
  ) {
    super (http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/mporigin'
    });
  }

  getTeilpakete(): Observable<TeilpaketKraft[]> {
    console.log("alle Teilpakete auslesen!");
    return super.get('/tpaket').pipe(
      map((res:TeilpaketKraft[]) => {
      return res;
    }));
  }

  async getTeilpaketeFiltered(): Promise<any> {
     console.log("aktuellste Teilpakete auslesen für angemeldeten User");
     const response = await this.http.get(`${environment.apiHost}` + '/makpak/mporiginfiltered').toPromise();
     return response.json();
  }


   getLatestTeilpaketHist(paketid: string): Observable<any>{
    console.log("aktuellste Teilpaketdetails auslesen für id: " + paketid);
    return this.http.get(`${environment.apiHost}` + '/makpak/mphistpaketid/' + paketid).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }))
  }

   sendIdInUse(paketid: string): Observable<any> {
    console.log("problem place after upload file: " + paketid);
    return this.http.get(`${environment.apiHost}` + '/makpak/sendId/' + paketid).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }))
  }

  deleteTeilPaket(mpOriginId: string): Observable<any> {
    console.log("Löschen eines Teilpakets - " + mpOriginId);
    return this.http.delete(`${environment.apiHost}` + '/makpak/mporm/' + mpOriginId,  { withCredentials: true }).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      })) /* */;
  }

  updateTeilpaket(teilpaketKraft: any): Observable<any> {
    console.log("Teilpaket aktualisieren");
    let formData: FormData = new FormData();
    formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
    return this.http.post(`${environment.apiHost}` + '/makpak/mporiginupdate', formData, { withCredentials: true }).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: TeilpaketKraft[]) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }

  updateTeilpaketStatus(mpOriginId: string, mpNewStatus: string, bensl: string): Observable<any> {
    console.log("Status des Teilpaket aktualisieren");

    let formData: FormData = new FormData();
    formData.append("mpOriginId", mpOriginId);
    formData.append("mpOriginNewStatus", mpNewStatus);
    formData.append("bensl", bensl);

    return this.http.post(`${environment.apiHost}` + '/makpak/mporiginupdatestatus', formData, { withCredentials: true }).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: TeilpaketKraft[]) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }
}
